import { QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "jotai";
import React from "react";

import { Alert } from "@/components/Interface/Alert/Alert";
import { VersionUpdateNotification } from "@/components/VersionUpdateNotification/VersionUpdateNotification";
import { useHandleError } from "@/hooks/useHandleError";
import { useQueryClient } from "@/hooks/useQueryClient";
import { DataContextProvider } from "@/provider/DataContextProvider";
import { FullScreenLoadingProvider } from "@/provider/FullScreenLoadingProvider/FullScreenLoadingProvider";
import { DEFAULT_THEME, themes } from "@/themes";
import { applyTheme } from "@/themes/themeUtils";
import { store } from "@/utils/atoms";

export const PartnerAppProviders: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const handleError = useHandleError();
  const queryClient = useQueryClient(handleError);
  applyTheme(themes[DEFAULT_THEME]);

  return (
    <Provider unstable_createStore={() => store}>
      <QueryClientProvider client={queryClient}>
        <FullScreenLoadingProvider>
          <DataContextProvider>
            <VersionUpdateNotification />
            <Alert />
            {children}
          </DataContextProvider>
        </FullScreenLoadingProvider>
      </QueryClientProvider>
    </Provider>
  );
};
